import { Tr } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import { StyledTd } from '@/ui/modules/operational/components/Table/StyledTd'

export default function TableRowNotFound({
  emptyMessage
}: {
  emptyMessage?: string
}) {
  const { t } = useTranslation()

  return (
    <Tr>
      <StyledTd colSpan={9999}>
        {emptyMessage ?? t('general.common.exceptions.NotFound')}
      </StyledTd>
    </Tr>
  )
}
